var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"host-contacts"},[_c('Map'),_c('Location'),_c('Logistics')],1)}
var staticRenderFns = []

export { render, staticRenderFns }